import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph, Icon } from 'components';
import { ICON_TYPES } from 'config';
import './Button.scss';

const Button = ({
  tag: Tag,
  additionalClass,
  children,
  color,
  arrowColor,
  order,
  transparent,
  type,
  underline,
  ...other
}) => {
  const orderClass = order ? `button--${order}` : '';
  const colorClass = transparent
    ? color && `button--transparent-${color}`
    : `button--${color}`;
  const underlineClass = underline ? 'button--underline' : '';
  const buttonProps = {
    className: `button ${orderClass} ${colorClass} ${underlineClass} ${additionalClass}`,
    ...other,
  };

  const button = Tag ? (
    <Tag {...buttonProps}>{children}</Tag>
  ) : (
    // eslint-disable-next-line react/button-has-type
    <button type={type} {...buttonProps}>
      {children}
    </button>
  );

  return (
    <>
      {order === 'secondary' ? (
        <div className={`${orderClass} ${additionalClass}`}>
          <Paragraph color={color} additionalClass={'text--bold'}>
            {children}
          </Paragraph>
          <Icon
            icon={ICON_TYPES.RIGHT_ARROW}
            size={'medium'}
            color={arrowColor || color}
          />
        </div>
      ) : (
        button
      )}
    </>
  );
};

Button.defaultProps = {
  tag: null,
  additionalClass: '',
  order: 'primary',
  color: '',
  arrowColor: '',
  type: 'button',
  transparent: false,
  underline: false,
};

Button.propTypes = {
  tag: PropTypes.elementType,
  additionalClass: PropTypes.string,
  order: PropTypes.string,
  color: PropTypes.string,
  arrowColor: PropTypes.string,
  type: PropTypes.string,
  transparent: PropTypes.bool,
  underline: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Button;
